export const aggregateHeatmapItems = (
    items,
    { property, xAxisCategoryProperty, yAxisCategoryProperty }
) => {
    const xAxisCategories = [];
    const yAxisCategories = [];
    const xIndex = new Map();
    const yIndex = new Map();
    // x index -> Map<y index, summed value>
    const valueMap = new Map();

    for (const item of items || []) {
        const xRaw = item[xAxisCategoryProperty];
        const yRaw = item[yAxisCategoryProperty];
        const valRaw = item[property];

        if (xRaw === null || xRaw === undefined) continue;
        if (yRaw === null || yRaw === undefined) continue;
        if (valRaw === null || valRaw === undefined) continue;

        const num = typeof valRaw === 'number' ? valRaw : parseFloat(valRaw);
        if (Number.isNaN(num)) continue;

        const x = String(xRaw);
        const y = String(yRaw);

        let xi = xIndex.get(x);
        if (xi === undefined) {
            xi = xAxisCategories.length;
            xAxisCategories.push(x);
            xIndex.set(x, xi);
        }

        let yi = yIndex.get(y);
        if (yi === undefined) {
            yi = yAxisCategories.length;
            yAxisCategories.push(y);
            yIndex.set(y, yi);
        }

        let row = valueMap.get(xi);
        if (!row) {
            row = new Map();
            valueMap.set(xi, row);
        }
        row.set(yi, (row.get(yi) || 0) + num);
    }

    const data = [];
    for (const [xi, row] of valueMap) {
        for (const [yi, value] of row) {
            data.push([xi, yi, value]);
        }
    }

    return { xAxisCategories, yAxisCategories, data };
};
